import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { getLoginFlags, setLoginFlags } from "../../lib/auth";
import { useSecurityStatus } from "../../hooks/useSecurity";
import { SecurityDialog } from "./SecurityDialog";
import { ChangePasswordForm } from "./PasswordSection";

const DISMISSED = "panel_orquestador_security_banner_dismissed"; // «después»: solo hasta cerrar la pestaña

const dismissed = () => {
  try {
    return sessionStorage.getItem(DISMISSED) === "1";
  } catch (e) {
    return false;
  }
};

// Avisos de después de entrar: contraseña vencida (cambio obligatorio), reconfigurar los 2 pasos tras una recuperación, y un recordatorio discreto
// para activar los 2 pasos o cambiar la contraseña cuando está por vencer.
export function SecurityNotices() {
  const [flags, setFlags] = useState(() => getLoginFlags());
  const [openDialog, setOpenDialog] = useState(!!getLoginFlags().must_setup_totp);
  const [hidden, setHidden] = useState(dismissed());
  const { data: status } = useSecurityStatus(true);
  useEffect(() => {
    if (getLoginFlags().must_setup_totp) setLoginFlags({ ...getLoginFlags(), must_setup_totp: false }); // se abre una sola vez, no en cada pantalla
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const passwordChanged = () => {
    const next = { ...flags, must_change_password: false };
    setLoginFlags(next);
    setFlags(next);
  };
  const hide = () => {
    try {
      sessionStorage.setItem(DISMISSED, "1");
    } catch (e) {
      // sin almacenamiento de sesión: el aviso vuelve en la siguiente pantalla
    }
    setHidden(true);
  };

  const expiring = status && status.password_days_left !== null && status.password_days_left <= 14;
  const showBanner = !hidden && status && (!status.totp_enabled || expiring);
  return (
    <>
      {showBanner && (
        <div data-testid="security-banner" className="shrink-0 border-b border-amber-500/40 px-4 py-2 flex items-center justify-between gap-3 text-sm">
          <span className="text-muted-foreground">
            {!status.totp_enabled ? "🔐 Protege tu panel: activa la verificación en 2 pasos con Google Authenticator (5 minutos)." : `🔑 Tu contraseña vence en ${status.password_days_left} día(s). Cámbiala cuando puedas.`}
          </span>
          <span className="flex shrink-0 gap-2">
            <Button data-testid="security-banner-open" size="sm" variant="outline" onClick={() => setOpenDialog(true)}>{!status.totp_enabled ? "Configurar" : "Cambiarla"}</Button>
            <Button data-testid="security-banner-later" size="sm" variant="ghost" onClick={hide}>Después</Button>
          </span>
        </div>
      )}
      <SecurityDialog open={openDialog} onOpenChange={setOpenDialog} focus={status && status.totp_enabled ? "password" : "totp"} />
      <Dialog open={!!flags.must_change_password} onOpenChange={() => {}}>
        <DialogContent data-testid="forced-password-dialog" className="max-w-sm" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
          <DialogHeader>
            <DialogTitle>Tu contraseña venció</DialogTitle>
            <DialogDescription>Por seguridad, cámbiala ahora. Después sigues como siempre.</DialogDescription>
          </DialogHeader>
          <ChangePasswordForm onChanged={passwordChanged} submitLabel="Guardar contraseña nueva" />
        </DialogContent>
      </Dialog>
    </>
  );
}
